import { findKey, map } from "lodash";
import { Payload, Record } from "./types";

export const mappedBy = (payload: Payload<Record>, column: string): string | undefined =>
  findKey(payload.mapping, value => value.field === column);

export const selectValues = (
  payload: Payload<Record>,
  column: string,
  mapped = false,
): string[] => {
  if (mapped) {
    const name = mappedBy(payload, column);
    if (!name) return [];

    return selectValues(payload, name, false);
  }

  return map(payload.data, column);
};
